









































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component } from "vue-property-decorator";
import { $api } from "@/services/ApiService";
import { Certificate } from "bancojs";
import { $auth } from "@/services/AuthenticationService";
import { saveAs } from "file-saver";

@Component
export default class AdminCertificatesEdit extends Vue {
  async created() {
    if (this.$route.params.fingerprint) {
      try {
        const res = await $api.client.admin.certificates
          .get(this.$route.params.fingerprint)
          .toPromise();
        this.form.data = res;
      } catch (err) {
        console.log(err);
      }
    }
    this.form.loading = false;
  }

  async saveCertificate() {
    try {
      this.form.saving = true;
      const user = await $api.client.admin.certificates
        .update(this.form.data.fingerprint, this.form.data)
        .toPromise();
      this.form.saving = false;
      this.$router.push("/admin/certificates");
    } catch (err) {
      console.log(err);
      this.form.saving = true;
    }
  }

  get isAdmin() {
    return $auth.hasAnyAdmin();
  }

  get validAfter() {
    return new Date(this.form.data.valid_after).toLocaleString();
  }

  get validBefore() {
    return new Date(this.form.data.valid_before).toLocaleString();
  }

  downloadPEM() {
    const data = new Blob([this.form.data.pem], {
      type: "text/plain;charset=utf-8",
    });
    saveAs(data, "certificado.pem");
  }

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
  };

  form: {
    data: Certificate;
    loading: boolean;
    saving: boolean;
    validForm: boolean;
  } = {
    data: {
      fingerprint: "",
      state: "ACTIVE",
      user_id: "",
      key_id: NaN,
      csr_id: NaN,
      pem: "",
      valid_after: "",
      valid_before: "",
    },
    saving: false,
    loading: true,
    validForm: false,
  };
}
